import type { ResultadoImportacao } from "../../../services/clientesFornecedor"

export enum ImportacaoClientesActionsTypes {
    ATUALIZAR_CONTEUDO = "ATUALIZAR_CONTEUDO",
    DEFINIR_RESULTADO = "DEFINIR_RESULTADO",
    LIMPAR = "LIMPAR",
}

export type ImportacaoClientesActions =
    | { type: ImportacaoClientesActionsTypes.ATUALIZAR_CONTEUDO; payload: string }
    | { type: ImportacaoClientesActionsTypes.DEFINIR_RESULTADO; payload: ResultadoImportacao | null }
    | { type: ImportacaoClientesActionsTypes.LIMPAR }
